import React, { useEffect, useState } from "react";
import "./Form.css";
import useSOCopilotAdminPrompts from "../hooks/useSOCopilotAdmin";
import SubscriptionPlans from "./SubscriptionPlans";
import Prompts from "./Promps";

const LexIAPromptForm = () => {
  const [activePanel, setActivePanel] = useState<string>("PROMPTS");
  const [extensionId, setExtensionId] = useState<string>("");
  // const { plans } = useSOCopilotAdminPrompts(null, null, extensionId);

  const LEXIA_EXTENSION_ID = (window as any).env.REACT_APP_LEXIA_EXTENSION_ID;

  return (
    <div className="page page-lexia-admin">
      <div className="page-header">
        <h1 className="pagetitle">LexIAdmin</h1>
        <div className="ml-auto"></div>
        <div className="button-tabs">
          <ul className="nav tabs">
            <li
              className={
                activePanel === "PROMPTS" ? "nav-item is-active" : "nav-item"
              }
            >
              <a
                onClick={() => {
                  setActivePanel("PROMPTS");
                }}
              >
                Prompts
              </a>
            </li>
            <li
              className={
                activePanel === "PLANS" ? "nav-item is-active" : "nav-item"
              }
            >
              <a
                onClick={() => {
                  setActivePanel("PLANS");
                  setExtensionId(LEXIA_EXTENSION_ID);
                }}
              >
                Plans
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="page-content">
        {activePanel === "PROMPTS" && <Prompts />}
        {activePanel === "PLANS" && (
          <SubscriptionPlans
          //plans={plans}
          />
        )}
      </div>
    </div>
  );
};

export default LexIAPromptForm;
